import { render } from "./Zusatzobjekte.vue?vue&type=template&id=45242cec&scoped=true"
import script from "./Zusatzobjekte.vue?vue&type=script&lang=js"
export * from "./Zusatzobjekte.vue?vue&type=script&lang=js"

import "./Zusatzobjekte.vue?vue&type=style&index=0&id=45242cec&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45242cec"]])

export default __exports__